// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"213":"ae8a7e29","923":"0904f343"}[chunkId] + ".chunk.js");